import { CheckCircle, XCircle, WarningCircle, Clock } from "@phosphor-icons/react";

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
    });
  } catch { return iso; }
};

export const fmtSize = (bytes) => {
  if (!bytes && bytes !== 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const DESTINATION_LABEL = {
  download: "Download",
  drive: "Google Drive",
  email: "E-mail",
  auto: "Drive + E-mail",
  upload: "Upload local",
};

export const STATUS_BADGE = {
  success: { label: "Sucesso", cls: "bg-[#00A300] text-white", Icon: CheckCircle },
  partial: { label: "Parcial", cls: "bg-yellow-500 text-black", Icon: WarningCircle },
  failed:  { label: "Falha",   cls: "bg-[#E60000] text-white", Icon: XCircle },
  running: { label: "Rodando", cls: "bg-zinc-800 text-white",  Icon: Clock },
};

const TYPE_BADGE_CLASSES = {
  restore: "bg-[#E60000] text-white",
  auto: "bg-blue-100 text-blue-800",
  manual: "bg-zinc-200 text-zinc-800",
};

export function typeBadgeClass(type) {
  return TYPE_BADGE_CLASSES[type] || TYPE_BADGE_CLASSES.manual;
}

export function typeLabel(type) {
  if (type === "restore") return "RESTORE";
  if (type === "auto") return "AUTO";
  return "MANUAL";
}
